<template>
    <div style="background:white; height:100%">     
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;height:38px;border-bottom:2px solid #389;padding-top:3px">   
            <div style="width:70px;line-height:30px" >
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px; font-weight:600">新增 </span></el-link>
            </div>
            <span style=" margin-left:10px;font-size:12px;margin-right:10px;">字段查询 </span>
            <el-select v-model="selparam"  placeholder="请选择列名"   size="small" style="width:150px; ">
                <span v-for="item in tabCol" :key='item.key' >
                    <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input clearable ref="refinput" :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:320px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
            <span style="font-weight:600;color:black;font-size:12px;margin-right:10px;margin-left:15px">入库状态</span>
            <el-select @change="qryTabData"  v-model="t_stfg" size="small"  style="width:100px; " >                
                <el-option label="所有记录" value="ALL" ></el-option>
                <el-option label="未入库" value="N" ></el-option>
                <el-option label="已入库" value="Y" ></el-option>
            </el-select>
            <div style="font-weight:600;color:blue;font-size:13px;margin-left:15px;line-height:35px;height:30px">提示：已投料时字体为蓝色 , 已入库为绿色</div>
        </div> 
        <el-table  :data="tabData" 
            border                            
            disabled-hover
            class="custom-table-border"
            style="overflow:auto;margin-top:1px;"
            size="small"
            header-cell-class-name="clearPadding"
            :cell-style="{padding:'3px','font-size':'12px' }"
            :height="tabHeight" 
            :row-key="getRowKey"  
            ref="tabref" 
            @row-click="rowClick"
            :row-class-name="rowColor" 
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            highlight-current-row>      
            <el-table-column label="序号" type="index" width="60" fixed align="center">
                <el-table-column label="序号" type="index" width="60" fixed align="center">
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column  v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key"  :align="item.align"  show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-select v-if="item.key=='STFG'" @change="qryTabData" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                            <el-option label="已审" value="Y"  ></el-option>
                            <el-option label="未审" value="N"  ></el-option>
                        </el-select>
                        <el-date-picker v-else-if="item.edcss=='date'" @change="qryTabData" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                        <el-input type="number" placeholder="数字框"  @keyup.enter.native="qryTabData" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="qryTabData"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style=" border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">是</el-tag>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']!=='Y'" size="mini" type="info" effect="dark">否</el-tag>                         
                        <span v-else v-text="scope.row[item.key]" ></span>
                    </template>
                </el-table-column>  
            </el-table-column> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="215">
                <template slot-scope="scope">
                    <span v-if="scope.row.STFG=='Y' ">
                        <i class="iconfont icon-xiashuangjiantou" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                        <el-link :disabled="cancelBool" @click="nextGen(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:2px;">下推 </span></el-link>
                    </span> 
                    <i class="iconfont icon-chakan1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link :disabled="disabled" @click="editRec(scope.row,'Y' )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">查看 </span></el-link>
                    <span v-if="scope.row.STFG==='N' || v_username=='18025667613' " >
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="editRec(scope.row,'N')" :underline="false"  ><span style="font-size:12px;margin-right:2px;">编辑 </span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N' " >
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="stfgRec(scope.row,'K',scope.$index,'确认')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">确认</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='K' " >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="stfgRec(scope.row,'N',scope.$index,'弃认')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃认</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='K' " >
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click="stfgRec(scope.row,'Y',scope.$index,'审核')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">审核</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y' " >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click="stfgRec(scope.row,'K',scope.$index,'弃审')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃审</span></el-link>
                    </span>
                    <span v-if="scope.row['STFG']=='N'" > 
                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link  @click="stfgRec(scope.row,'X',scope.$index,'作废')" :underline="false" style="font-size:10px; "><span style="font-size:12px;">作废</span></el-link> 
                    </span>
                        
                </template>
            </el-table-column>                      
        </el-table>  
        <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-toolbar">
                    <span class="spanRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="medium" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="medium" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select size="medium" :disabled="item.DISABLED==='Y'?true:false||saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-input size="medium" :disabled="saveFlag" v-else-if="item.EDCSS==='button'" v-model="mainRow[item.FLDNO]"  @focus="inputBtn('','',item.FLDNO)" style="width:100%;border:1px solid #778898"></el-input>
                                <el-select size="medium" filterable v-else-if="item.key==='WKNO'"  :disabled="saveFlag" style="width:100%" v-model="mainRow[item.key]">
                                    <span v-for="(item ,index) in supArr " :key="index">
                                        <el-option  :label="item.SUPNM" :value="item.IDSEQ"></el-option>
                                    </span>
                                </el-select> 
                                <el-select size="medium" filterable v-else-if="item.key==='STAFF'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                    <el-row v-for="(item,index) in empArr " :key="index">
                                        <el-col :span="6">
                                            <el-option  :label="item.EMPNO" :value="item.USERNM"></el-option>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-option  :label="item.DEPTNM" :value="item.USERNM"></el-option>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-option  :label="item.USERNM" :value="item.USERNM"></el-option>
                                        </el-col>
                                    </el-row>
                                </el-select>
                                
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
                <div class="one-toolbar">
                    <span class="spanRow">  明细资料</span>
                    <el-link  :underline="false" @click="dtlAdd" :disabled="saveFlag">
                        【<i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:2px;margin-left:2px;color:white"></i><span style="font-size:12px;margin-right:5px;color:white"> 新增明细记录</span>】
                    </el-link> 
                </div>
                <el-table  :data="dtlData" 
                    border                    
                    size="small"
                    class="custom-table-border"
                    ref="refdtl"  
                    show-summary
                    :summary-method="getSummary"
                    :cell-style="{padding:'0px'}"
                    :row-key="getKey"
                    :row-class-name="tabRowClass"
                    cell-class-name="clearPadding"
                    @row-click="getRowClick"
                    :height="230" 
                    v-loading="t_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    highlight-current-row>      
                    <el-table-column type="index" label="序号" width="65"></el-table-column>
                    <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key" 
                        show-overflow-tooltip 
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :width="item.width">
                        <template slot="header">{{item.title}}<span v-if="item.notnull=='Y'" style="color:red">*</span></template>
                        <template slot-scope="scope"> 
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else-if="item.key=='STKNO'" >{{scope.row['STKNM']}}</span>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >
                                <el-input type="number" @input="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.down.native="nextLine(item.key,'down')" @keyup.up.native="nextLine(item.key,'up')"  :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter')"  size="mini" v-if="item.edcss=='number'" :controls="false"  v-model="scope.row[item.key]"  > </el-input>                                             
                                <el-select :ref="scope.$index+item.key"  size="mini" v-else-if="item.edcss=='select'"   v-model="scope.row[item.key]"  > 
                                    <el-option v-for="(it,index) in comboArr[item.key]" :key="index" :label="it.CNAME" :value="it.CODE"></el-option>
                                </el-select> 
                                <el-select  size="mini" v-else-if="item.key=='MATTY'" v-model="scope.row[item.key]">
                                    <el-option label="产成品" value="PRD"></el-option>
                                    <el-option label="原材料" value="MAT"></el-option>
                                    <el-option label="样板-模具-设计服务" value="SMP"></el-option>
                                </el-select>
                                <el-select @change="modelChange"  v-else-if="item.key==='TAX'" size="mini" v-model="scope.row[item.key]"   style="width:100%">
                                    <span v-for="item in taxArr" :key='item.key'>
                                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                                    </span>
                                </el-select>
                                <el-input readonly @focus="inputBtn(scope.row,scope.$index,item.key)" :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]"  > </el-input>     
                                <el-date-picker v-else-if="item.edcss=='date'" :clearable="false" value-format="yyyy-MM-dd" type="date" :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )"  size="mini" v-model="scope.row[item.key]"   > </el-date-picker>     
                                <el-input  v-else-if="item.disabled=='N'"  :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" size="mini" v-model="scope.row[item.key]"  > </el-input>                                      
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="75">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link @click="perDel(scope.row, scope.$index)" :underline="false" :disabled="saveFlag" ><span style="font-size:12px; ">删除</span></el-link>
                        </template>
                    </el-table-column>                        
                </el-table>
                <div class="one-toolbar">
                    <span class="spanRow">其它费用明细</span>
                    <el-link  :underline="false" @click="othAdd" :disabled="saveFlag">
                        【<i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:2px;margin-left:2px;color:white"></i><span style="font-size:12px;margin-right:5px;color:white"> 新增明细记录</span>】
                    </el-link> 
                </div>
                <el-table  :data="othData" 
                    border                    
                    size="small"
                    ref="refoth"  
                    :cell-style="{padding:'0px'}"
                    :row-key="getDtlKey"
                    class="custom-table-border"
                    cell-class-name="clearPadding"
 
                    :height="200" 
                    highlight-current-row>      
                    <el-table-column type="index" label="序号" width="65"></el-table-column>
                    <el-table-column  v-for="(item ) in othCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key" 
                        show-overflow-tooltip 
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :width="item.width">
                        <template slot="header">{{item.title}}<span v-if="item.notnull=='Y'" style="color:red">*</span></template>
                        <template slot-scope="scope"> 
                            <span v-if ="saveFlag" >
                                <span v-if="item.key=='FEENO2'" >{{scope.row['FEENM']}}</span>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >
                                <el-input type="number" @input="othPrc(scope.row,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"   size="mini" v-if="item.edcss=='number'" :controls="false"  v-model="scope.row[item.key]"  > </el-input>                                             
                                <el-select    size="mini" v-else-if="item.edcss=='select'"   v-model="scope.row[item.key]"  > 
                                    <el-option v-for="(it,index) in comboArr[item.key]" :key="index" :label="it.CNAME" :value="it.CNAME"></el-option>
                                </el-select> 
                                <el-select  v-else-if="item.key==='RATE'" size="mini" v-model="scope.row[item.key]"   style="width:100%">
                                    <span v-for="item in taxArr" :key='item.key'>
                                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                                    </span>
                                </el-select>  
                                <el-input  v-else-if="item.disabled=='N'"     size="mini" v-model="scope.row[item.key]"  > </el-input>                                      
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="75">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link @click="othDel(scope.row, scope.$index)" :underline="false" :disabled="saveFlag" ><span style="font-size:12px; ">删除</span></el-link>
                        </template>
                    </el-table-column>                        
                </el-table>
                <div class="one-toolbar">
                    <span class="spanRow">上传附件</span>
                </div>
                <div style="display:flex" >
                    <Upload
                        :disabled="saveFlag"
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :with-credentials="true"                            
                        :format="['jpg','jpeg','png','gif','tiff','pdf' ]"
                        :max-size="4096"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :on-progress="handleProgress"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex;margin-left:30px;"  >
                        <span v-for="(item,index) in imgData" :key="index">  
                            <div v-if="item.FILEPATH&&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:180px;height:140px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image :preview-src-list="[item.FILEPATH]"   v-else   style="width:180px;height:140px;margin-right:30px;" :src="item.FILEPATH"/> 
                            <div style="height:25px;background:#e8eaec;width:180px; display:flex;justify-content:space-between">
                                <el-link :disabled="saveFlag" :underline="false" style=" font-size:10px" @click="imgDel(item.IDSEQ,item.LSTSEQ,item.FILEPATH,index)"><Icon type="md-close" /> 删除</el-link>
                                <el-link v-if="item.FILEPATH.lastIndexOf('pdf')>-1" :underline="false" style="margin-right:2px;font-size:10px" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" />查看</el-link>
                            </div>
                        </span>
                    </div> 
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button :disabled="saveFlag" @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 销售订单 -->
        <el-dialog v-dialogDrag :visible.sync="saleWin" width="1100px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">销售订单选择</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <saleSel   @child-sure="ordSel"></saleSel>
            </div>
        </el-dialog>
 
        <!-- 物料选择  -->
        <el-dialog v-dialogDrag :visible.sync="matWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">物料选择</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <matSel @child-matobj="matSure" v-bind:v_type="sendVal" ></matSel>
            </div>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_cond="t_cond" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog> 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>
        <!-- 下推费用明细 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="finWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">下推应付明细</span>
            </div> 
            <div class="one-toolbar">
                <span class="spanRow"  ></span> 
                <el-checkbox @change="selPay" true-label="Y" false-label="N" v-model="selAll" style="line-height:30px; margin-right:2px; "><span style="font-size:12px;color:white">全选</span></el-checkbox>
                <span style="margin-left:6px">字段</span>
                <el-select v-model="selparam4"  placeholder="请选择列名"   size="small" style="width:150px; margin-left:4px">
                    <span v-for="(item,index) in feeCol" :key='index' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'&&item.edcss!=='checkbox'"></el-option>
                    </span>
                </el-select>
                <el-input clearable  :placeholder="input_hold" v-model="txtparam4" @keyup.enter.native="qryFee" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper4" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryFee" ></el-button>
                </el-input>
                <el-button type="primary" @click="nextPay" size="small" icon="iconfont icon-shipeiqi" style=" margin-left:10px;height:30px;margin-top:2px;line-height:15px">下推选择记录</el-button>
            </div>
            <el-table  :data="payData.filter(item=>item.ISNEXT=='N')" 
                border                            
                size="small"
                class="custom-table-border"
                :row-key="getPayKey"
                :cell-style="{padding:'2px' }"
                :height="400" 
                ref="refnext"
                v-loading="d_loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                :header-cell-style="headStyle"
                @row-click="nextClick"
                :row-class-name="tabRowClass"
                cell-class-name="clearPadding"
                highlight-current-row >
                <el-table-column label="序号" type="index" width="60"></el-table-column>         
                <el-table-column v-for="(item ) in feeCol.filter(item=>item.thide=='N'&&item.key!=='RN')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :min-width="item.width">
                    <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-input type="number" :disabled="v_radio!=='STK'" @input="nextPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.key=='PRC'||item.key=='STKQTY' " @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"  v-model="scope.row[item.key]" size="mini" style="width:100%"></el-input>
                        <el-select    size="mini" v-else-if="item.key=='STKNO'"  v-model="scope.row[item.key]"  > 
                            <el-option v-for="(it,index) in comboArr[item.key]" :key="index" :label="it.CNAME" :value="it.CODE"></el-option>
                        </el-select> 
                        <el-input v-else-if="item.key=='RMK'" v-model="scope.row[item.key]" size="mini" style="width:100%" clearable></el-input>
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
            </el-table>
            <el-table  :data="nextData" 
                border                            
                size="small"
                ref="refpay"
                class="custom-table-border"
                :cell-style="{padding:'2px'}"
                :row-key="getDtlKey"
                :height="maxHeight" 
                :header-cell-style="headStyle"
                highlight-current-row > 
                <el-table-column label="序号" type="index" width="60"></el-table-column> 
                <el-table-column v-for="(item ) in feeCol.filter(item=>item.thide=='N'&&item.key!=='SEL'&&item.key!=='RN')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :min-width="item.width">
                    <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="75">
                    <template slot-scope="scope">
                        <el-button size="mini"   type="text" icon="el-icon-close" @click="payDel(scope.row,scope.$index)">删除</el-button>   
                    </template>
                </el-table-column>
            </el-table>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="finWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button v-if="v_radio=='FEE'" @click="genPay('FEE')" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-shengcheng"  >生成应付单 </el-button> 
                    <el-button v-if="v_radio=='STK'" @click="genPay('STK')" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-shengcheng"  >生成入库单 </el-button> 
                    <el-button v-if="v_radio=='PRD'" @click="genPay('PRD')" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-shengcheng"  >生成投料单 </el-button>
                </span>
            </div>
        </el-dialog> 
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <!-- 下推单据 -->
        <el-dialog v-dialogDrag :visible.sync="nextWin" width="400px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">下推单据</span>
            </div>
            <div>
                <el-radio v-model="v_radio" label="STK" border>下推委外入库单</el-radio>
                <!-- <el-radio v-model="v_radio" label="FEE" border>下推应付单据</el-radio> -->
                <el-radio v-model="v_radio" label="PRD" border>下推生产投料</el-radio>
            </div>
            <span slot="footer"  >
                <el-button type="info" size="small" @click="nextWin = false" style="margin-right:40px;">取 消</el-button>
                <el-button type="primary" size="small" @click="nextSure(v_radio)">确 定</el-button>
            </span> 
        </el-dialog>
    </div>
</template>
<script>
import pubWin from '../datamgt/pubwin.vue' 
import repWin from '../datamgt/repWin.vue'  
import matSel from '../datamgt/material.vue' 
import saleSel from '../ordmgt/sale_ref.vue' 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate } from '../../api/Select' 
//局部注册
export default {
    name:"out_product",
    data () {
        return {
            nextWin:false,
            Accept: "png,jpg,jpeg,gif,tiff,pdf", //上传文件格式限制 'jpg','jpeg','png','gif','tiff'
            allSel:'N',
    
            rmkval:'',
            othData:[],
            prodCol:[],
            t_cond:'',
            t_stfg:'N',
            feeCol:[],
            repWin:false,
            repUrl:'',
            supArr:[],
            drawer:false,
            matWin:false,
            saleWin:false,
            perFlag:'create',
            dtlRow:{},
            sendVal:'PRD',
            saveFlag:false,
            v_row:{},
            promptWin:false,
            prodWin:false,
            prompt:'',
            selparam3:'IDNO',
            oper3:'like',
            txtparam3:'',
            selparam4:'',
            oper4:'like',
            txtparam4:'',
            tmplRmk:'',
            stfgCss:'',
            chkIndex:'',
            stfgColor:'',
            mainRow:{},
            input_hold:'请输入查询的值',
            othCol:[],
            listIndex:'-1',
            active:'', //二级菜单选中标志
            stfg_:'ALL',
            v_radio:'STK',
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            dtlValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabCol:[], //表列
            dtlData:[], //明细数据
            dtlCol:[],
            operArr:[],
            v_loading:false,
            oper:'like',
            oper2:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
 
            delArr:[],
            othArr:[],
            empArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            notDtl:[],
            current:1,
            taxArr:[],
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            t_loading:false,
            d_loading:false,
            v_stknm :'',
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            v_key:'',
 
            v_tabIndex:'',
            saleCol:[],
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            nextData:[],
            v_idseq:'',
            selAll:'N',
            finWin:false,
            payData:[],
            maxHeight:'',
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            delImg:[],
            v_tabrow:{},
 
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
        }
    },
    mounted () { 
        this.showkey()
        this.maxHeight = document.documentElement.clientHeight - 560
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','16568','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','16568','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //下推
                    this.cancelBool=true
                }
            }
        })  
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
 
        //表单所以下拦框动态赋值
        this.comSelect()
        //供应商(委外加工类型)
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'supty','399986','v_bs_sup','').then(res=>{
            this.supArr =res.result
        })
        //人员资料
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','V_SYS_USER','').then(res=>{
            this.empArr =res.result
        })
 
 
        getBaseData('xuper_auth/getBaseData','PARENTNO','249','','','v_sys_base','').then(res=>{
            this.taxArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','16568','gpnm,gpsort','','lstseq','2304', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16568','LSTSEQ','2304','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
 
        this.$nextTick(()=>{
            this.$refs['refinput'].focus()
        })
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 700) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
        reqHeight: function() {
            return (window.innerHeight - 460) + 'px';
        }, 
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    components: {
        repWin,
        pubWin,
        saleSel, //销售订单
        matSel, //原材料
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.getTabList('')
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
 
    methods: { 
        rowColor({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            if (row['ISSTK']=='Y') {  //未开始
                return 'green-front'
            }else if (row['ISPICK']=='Y') {  //未开始
                return 'blue-front'
            }else{
                return 'black-front'
            }
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.qryTabData()
        } ,
        //预览PDF
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='AMT' ){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        //图片删除，操作数组
        imgDel(idseq,lstseq,path,index){
            this.$confirm('你确定要删除此附件吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:idseq,LSTSEQ:lstseq,IMGPATH:path}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择正确的图片格式 '
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出4M' 
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {        
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
 
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            } else{
                this.promptWin =true
                this.prompt =res.result
            }                  
        },
        payDel(row,index){
            this.payData.push(JSON.parse(JSON.stringify( Object.assign(row,{ISNEXT:'N', SEL:'N'}))))
            this.nextData.splice(index,1)          
        },
        selPay(){
            this.payData.forEach(item=>{
                item['SEL']=this.selAll
            })
        },
        nextClick(row){
            this.chkIndex =row.index
        },
        getPayKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        nextPay(){   
            if (this.payData.filter(item=>item.SEL=='Y').length >0) {
                this.payData.forEach((item,index)=>{
                    if (item.SEL=='Y' &&item['ISNEXT']=='N' ){    
                        item['ISNEXT']='Y'
                        this.payData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'Y',SEL:'N'}))))
                        //this.nextData.push(JSON.parse(JSON.stringify(item)))
                        this.nextData.push(JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'N','SEL':'N'}))))
                    }            
                })
            }else{
                this.promptWin =true
                this.prompt ='请选择记录'
            }
        },
        //生成应付单
        genPay(val){
            let v_qtyFlag =false,v_stkFlag =false 
            if (this.nextData.length==0){
               this.promptWin =true
               this.prompt ='下推的记录不能为空' 
            }else{
                this.nextData.some(item=>{
                    if (!item['OKAMT'] ||item['OKAMT']==0 ){
                        v_qtyFlag =true
                    }
                    if (!item['STKNO']){
                        v_stkFlag =true
                    }
                })
                if (v_qtyFlag && this.v_radio=='FEE'){ // 
                    this.promptWin =true
                    this.prompt ='请检查下推记录：应付金额>0'
                }else if (v_stkFlag && val=='STK'){
                    this.promptWin =true
                    this.prompt ='请检查下推记录：入库仓库不能为空'
                }else {
                    let v_com = val=='FEE' ?'你确定要下推生成应付单吗':val=='PRD'?'你确定要下推生成投料单吗':'你确定要下推生成入库单吗'
                    let v_url = '',v_msg=''
                    if (val=='FEE'){
                        v_msg ='已成功下推应付单，请到费用报销单界面中查看'
                        v_url ='xuper_auth/next_genpay'
                    }else if (val=='STK'){
                        v_msg ='已成功下推入库单，请到成品入库单界面中查看'
                        v_url ='xuper_auth/next_genstk'
                    }else {
                        v_msg ='已成功下推投料单，请到生产投料单界面中查看'
                        v_url ='xuper_auth/next_genpay'
                    } 
                    this.$confirm( v_com,'提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        let v_json =JSON.stringify(this.nextData)
                        let v_action =''
                        if (val =='PRD'){
                            v_action ='PRDNEXT'+this.v_username+getDate('full')
                        }else{
                            v_action ='OUT'+this.v_username+getDate('full')
                        }
                        this.$axios({   
                            method: 'post',
                            url: v_url,
                            data: { corpid:this.v_corpid,p_json: v_json,p_user: this.v_username,p_action:v_action},
                        }).then(res=>{ 
                            if (res.code=='200'){        
                                this.$notify({
                                    title: '成功',
                                    message: v_msg ,
                                    type: 'success'
                                });
                            }else{
                                this.promptWin =true
                                this.prompt ='下推失败！'+res.result
                            }
                            this.finWin =false
                        })
                    }).catch(()=>{})   
                }             
            }
        },
        getFeeNext(idseq){
            let cond_=''
            if (this.selparam4){ //列1
                if (this.oper4==='like'){
                    cond_=cond_+' and  '+this.selparam4+'  like  \'%' + this.txtparam4+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam4  +this.oper4+' \''+this.txtparam4+'\' '
                }
            }
            this.payData=[]
            this.d_loading=true
            getTabColOrData(this.v_url,'V_PC_OUTREP','idseq',idseq,'','','','',cond_).then((res) => {    
                this.payData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refpay'].doLayout()
                    this.d_loading=false
                })
            })
        },
        qryFee(){
            if (this.v_idseq){
                this.getFeeNext(this.v_idseq)
            }
        },
        //下推
        nextGen(row,index){
            this.nextWin =true
            this.v_tabrow =JSON.parse(JSON.stringify(row))
            this.v_tabIndex =index
            this.v_idseq =row['IDSEQ']  
        },
        nextSure(val){
            this.finWin=true
            this.getFeeNext(this.v_idseq)
            this.selAll='N'
            this.nextData=[]  
            this.nextWin =false
        },
        nextPrc(row,index,key){
            if (key=='PRC'|| key=='STKQTY' ){
                row['PAYAMT']= (Number(row['STKQTY'])*Number( row['PRC'])).toFixed(2)
            }
        },
        othPrc(row ,key ){
            if (key=='PRC'|| key=='QTY' ){
                row['AMT']= (Number(row['QTY'])*Number( row['PRC'])).toFixed(2)
            }
        },
        qtyPrc(row,index,key){
            if (key=='PRC'|| key=='QTY' ){
                if (row['QTY'] && row['PRC']) 
                row['AMT'] = (Number(row['QTY'])*Number( row['PRC'])).toFixed(2)      
            }
        },
        modelChange(){
            this.$forceUpdate()
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{MATTYNM:obj['MATTYNM'],MATNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],UNITNM:obj['UNITNM']} ))
                this.$refs[ this.v_tabIndex+'QTY'][0].focus()  
                this.chkIndex =this.v_tabIndex
            }else if (this.v_key =='ORDNO'){
                //Object.assign(this.mainRow,{ORDNO:obj['IDNO']})
                Object.assign(this.mainRow,{REFIDSEQ:obj['IDSEQ'],REFLSTSEQ:obj['LSTSEQ'],ORDNO:obj['IDNO'],MATNO:obj['MATNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],QTY:obj['QTY']})
            }    
            this.btnWin =false
        },
        inputBtn( row, index, key){
            this.v_key =key    
            if (key =='MATNO'){ //物料
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='v_bs_mat'
                this.tableCol =this.prodCol
                this.v_key2 ='modelno'
                this.v_value2 =row['MATTY']
                this.t_cond=''
                if (!row['SRCIDNO'])
                this.btnWin =true
            }else if (key=='ORDNO'){
                this.v_table ='V_ordITM'
                this.tableCol =this.saleCol
                this.t_cond=''
                this.v_key2 =''
                this.v_value2=''
            }
            this.btnWin =true
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        // 明细select框改变时
        comChg(key,val,arr){
          if (key =='STKNO'){
            arr.some(item=>{
              if (item['CODE']==val)
                this.v_stknm  =item['CNAME']
            })
  
          }
          
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
 
        //销售订单选择
        ordSel(data_){
            if (data_.length>0){ //IDNO,MATNM,MATDESC,MODELNM,MATTYNM,PRC,TTLAMT,QTY ::TAXPRC,AMT
                for(let k=0;k<data_.length;k++){
                    let obj_={}
                    Object.assign(obj_,{MATNO:data_[k].MATNO,MATNM:data_[k].MATNM,MATDESC:data_[k].MATDESC,IDSEQ:this.rowIdseq,LSTSEQ:'',
                     QTY:data_[k].QTY, REFIDNO:data_[k].IDNO,REFIDSEQ:data_[k].IDSEQ,REFLSTSEQ:data_[k].LSTSEQ})
                    this.dtlData.push(obj_)
                }   
            }
            this.saleWin=false
        },

        //产品选择
        matChoose(){
            if(this.dtlRow['MATTY']==='PRD'){
                this.prodWin=true
            }else{
                this.matWin=true
            }
        },
        matOk(row){
            this.dtlRow['MATNO']=row['IDNO']
            this.dtlRow['MATNM']=row['MATNM']
            this.dtlRow['MATDESC']=row['MATDESC']
            this.dtlRow['UNITNM']=row['UNITNM']
            this.dtlRow['MATTYNM']=row['MATTYNM']
            this.prodWin=false
        },
        matSure(row){
            this.dtlRow['MATNO']=row['IDNO']
            this.dtlRow['MATNM']=row['MATNM']
            this.dtlRow['MATDESC']=row['MATDESC']
            this.dtlRow['UNITNM']=row['UNITNM']
            this.dtlRow['MATTYNM']=row['MATTYNM']
            this.matWin=false
        },
 
        //表行点击事件
        rowClick(row){
            
        },
        headStyle({column,columnIndex}){
            return 'height:29px'
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        getRowClick(row){
            this.chkIndex =row.index
        },
         //表格行 按回车键 到下一行
        nextLine(key,val ){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    v_count =this.dtlData.length                 
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    this.$refs[ this.chkIndex+'QTY'][0].focus()  
                }else{
                    let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                    v_col.some((item,index)=>{
                        if (item.key==key){
                            this.$refs[ this.chkIndex+ v_col[index+1].key][0].focus()  
                        }
                    })
                } 
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1       
                if (this.chkIndex >=this.dtlData.length) {
                    this.chkIndex =0
                }
                this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])           
                this.$refs[this.chkIndex+key][0].focus()             
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }                            
                this.$refs[ this.chkIndex+key][0].focus()  
                this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])       
            }                    
        },
        othDel(row,index){
            this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.othData.splice(index,1)
                this.othArr.push(row)
            }).catch(()=>{})
        },
        perDel(row,index){
            this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.dtlData.splice(index,1)
                this.delArr.push(row)
            }).catch(()=>{})
        },
        dtlAdd(){
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row['MATTY'] ='PRD'
            this.dtlData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
        },
        othAdd(){
            let v_row ={}
            this.othCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row['QTY'] =1
            this.othData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refoth'].doLayout()
            }) 
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'16568',p_cond:' and lstseq in (2304,2305,2306,2307)',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {    
                let obj_ ={}, v_title='' ,v_amt=0
                // 明细记录非空校验
                this.dtlData.forEach(item => {
                   item['CORPID'] =this.v_corpid
                   if (item['AMT']){
                     v_amt =Number(v_amt)+Number(item.AMT)
                   }
                   this.dtlCol.filter(item =>item.notnull=='Y').some(it =>{
                       if (!item[it.key]){
                           v_title =it['title']
                           return true
                       }
                   }) 
                }) 
                this.othData.forEach(item => {
                   if (item['AMT']){
                     v_amt =Number(v_amt)+Number(item.AMT)
                   }
                   this.othCol.filter(item =>item.notnull=='Y').some(it =>{
                       if (!item[it.key]){
                           v_title =it['title']
                           return true
                       }
                   }) 
                })
                if (v_title){
                    this.promptWin =true
                    this.prompt =v_title +'不能为空'
                }else{
                    
                    Object.assign(obj_,vm.mainRow,{ 'CORPID':this.v_corpid ,AMT:v_amt.toFixed(2)}) 
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(obj_), p_table:'pc_out',frmid:'16568'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            //明细保存：批量保存  res.idseq
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'pc_outdtl',p_idseq:idseq_,p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promptWin=true
                                    this.prompt=res.result
                                }
                            })
                            //明细删除
                            if (this.delArr.length>0) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.delArr), p_table:'pc_outdtl',p_idseq:idseq_,p_action:'D' },
                                })
                            }   
                            // 2.1 费用明细保存
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.othData), p_table:'pc_outfee',p_idseq:idseq_,p_action:'S' },
                            }) 
                            //2.3. 费用明细删除
                            if (this.othArr.length>0) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/batDtlSave2',
                                    data: {p_json:JSON.stringify(this.othArr), p_table:'pc_outfee',p_idseq:idseq_,p_action:'D' },
                                })
                            } 
                            //3、图片保存
                            for(var k=0;k<this.imgData.length;k++){
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                                })
                            }  
                            //图片删除处理
                            for(let k=0;k<this.delImg.length;k++){
                                let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                                }).then(res=>{          
                                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                        this.$axios({
                                            method: 'post',
                                            url: '/xuper_oss/ftpDelete',
                                            data: {p_path:'/volume1'+v_path},
                                        }).then(res=>{ 
                                            console.log(res.result)
                                        })
                                    }
                                })  
                            }   
                            this.delImg=[]
                            vm.drawer =false   
                            vm.getTabList('')
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            }
        },
 
        //订单明细
        getTabList(cond){
            this.v_loading =true   
            if (this.t_stfg !=='ALL'){
                cond =cond + ' and isstk=\''+this.t_stfg +'\''
            }    
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by '+this.selparam+' desc',p_table:'V_pc_out'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.code+':'+res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.tabref.doLayout()
                    this.v_loading =false
                })
            }) 
        },
        //查询明细数据
        getDtlData(idseq){
            this.dtlData=[]
            this.t_loading=true
            getTabColOrData(this.v_url,'V_PC_OUTDTLQRY','idseq',idseq,'','','','',' order by lstseq').then((res) => {               
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                    this.t_loading=false
                }) 
            })
            this.othData =[]
            getTabColOrData(this.v_url,'V_pc_outfee','idseq',idseq,'','','','',' order by lstseq').then((res) => {               
                this.othData =res.result  
                this.$nextTick(()=>{
                    this.$refs['refoth'].doLayout()
                }) 
            })
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tabData = this.allData.slice(_start,_end);
        },
        //状态变更
        stfgRec(row,val,index,v_comm){
            if (row['STKINNO']  ){
                this.promptWin =true
                this.prompt ='此单据已生成入库，不能操作'
            }else {
                this.$confirm('你确定要'+v_comm+'此单据吗?','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    type:'info',
                }).then(()=>{
                    var vm=this ,v_cond='',v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser=''
                    if (val =='K') {
                        if( v_comm=='弃审'){
                            v_cfmdttm =''
                            v_cfmuser =''
                        }else{
                            v_cfmdttm =getDate('full')
                            v_cfmuser =this.v_usernm
                        }
                        v_chkuser='',v_chkdttm=''
                        v_cond =' set stfg=\''+val+'\',cfmuser=\''+v_cfmuser+'\',cfmdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
                    }else if (val =='Y'){
                        v_chkdttm =getDate('full')
                        v_chkuser =this.v_usernm
                        v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
                    }else{
                        v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                        v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',cfmuser=\''+v_cfmuser+'\',cfmdttm=\''+v_cfmdttm+'\''
                    }
                    // 弃审时判断有没下推过 投料单
                    if (row['PICKNO'] && val=='K'){
                        this.promptWin =true
                        this.prompt ='此单据已下推生产投料单，不能弃审'
                    }else {
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'pc_out',p_cond: v_cond},
                        }).then(res=>{      
                            if(res.code =='200')  {
                                if (val=='X'){
                                    this.tabData.splice(index,1)
                                }else{       
                                    Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm,CFMUSER:v_cfmuser,CFMDTTM:v_cfmdttm})           
                                }
                            }else{
                                this.prompt=res.result
                                this.promptWin =true
                            }        
                        })
                    }
                
                }).catch(()=>{})
            }
        },
        editRec(row,val){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{ 
               this.saveFlag=false
            }
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.drawer=true   
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            })   
            this.getDtlData(row.IDSEQ) 
            this.qryImgData(row.IDSEQ)          
        },
        //查询附件数据
        qryImgData(idseq){
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'','').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
        getKey(row){
            return row.index
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            if (row['IDSEQ'] && row['LSTSEQ'])
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else if (this.oper==='!='){
                    cond_=cond_+' and  '+this.selparam+' is null '  
                }else{
                    cond_=cond_+' and  '+this.selparam +this.oper+' \''+this.txtparam+'\' '
                }
            }
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                    }

                }
            })
            this.getTabList( cond_+v_cond)
        },
        //新增 
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.mainRow={DTTM:getDate('day'), STAFF:this.v_usernm, STFG:'N'}
            this.saveFlag=false
            this.dtlData=[]
            this.imgData=[] 
            this.delImg =[]
            this.delArr =[]
            this.othArr =[]
            this.othData=[]
        },
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16568','lstseq','2304','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16568','lstseq','2305','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
            
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','123','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.saleCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16568','lstseq','2306','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.feeCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16568','lstseq','2307','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.othCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
 
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        height:18px;
    }
    .active { 
        color:#D200D2; 
    } 
 
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .cellClass{
        border:1px solid green;
       
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 